<div class="custom-action">
    @if (
        entity === 'shg_profile_component' &&
        rowData['view_status'] === 'Approved by BPM' &&
        rowData['status'] === 1
    ) {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            <button
                mat-menu-item
                (click)="onRequestMenuItemClick('registration_certificate')"
            >
                {{ 'registrationCertificate' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button
                mat-menu-item
                (click)="onRequestMenuItemClick('resolution_copy')"
            >
                {{ 'resolutionCopy' | translate }}
            </button>
        </mat-menu>
    }

    @if (entity === 'potential_didi_list_component') {
        <lokos-button
            [type]="'icon'"
            [isIcon]="true"
            [iconPath]="'assets/images/eye.svg'"
            (afterClick)="onRequestMenuItemClick('view')"
            [changeIconTheme]="true"
            [iconWidth]="'1.5rem'"
            [iconHeight]="'1.5rem'"
        />
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            <button
                mat-menu-item
                (click)="onRequestMenuItemClick('approve')"
                [disabled]="rowData.ldd_status !== 2"
            >
                {{ 'approve' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button
                mat-menu-item
                (click)="onRequestMenuItemClick('reject')"
                [disabled]="rowData.ldd_status !== 2"
            >
                {{ 'reject' | translate }}
            </button>
        </mat-menu>
    }

    @if (entity === 'potential_didi_approve_component') {
        <lokos-button
            [type]="'icon'"
            [isIcon]="true"
            [iconPath]="'assets/images/eye.svg'"
            (afterClick)="onRequestMenuItemClick('view')"
            [changeIconTheme]="true"
            [iconWidth]="'1.5rem'"
            [iconHeight]="'1.5rem'"
        />
        @if (rowData.ldd_status === 3) {
            <img
                src="assets/images/threeDot.svg"
                alt="threeDot"
                class="click-area"
                [mat-menu-trigger-for]="requestMenu"
            />
            <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
                <button
                    mat-menu-item
                    (click)="onRequestMenuItemClick('delete')"
                >
                    {{ 'deleteProfile' | translate }}
                </button>
            </mat-menu>
        }
    }

    @if (entity === 'potential_didi_verification_component') {
        @if (rowData.published || rowData.approvalStatus === 'Approved') {
            <img
                src="assets/images/threeDot.svg"
                alt="threeDot"
                class="click-area"
                [mat-menu-trigger-for]="requestMenu"
            />
            <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
                @if (rowData.approvalStatus === 'Approved') {
                    <button
                        mat-menu-item
                        (click)="onRequestMenuItemClick('declare')"
                    >
                        {{ 'declare' | translate }}
                    </button>
                    <mat-divider></mat-divider>
                }
                @if (rowData.published) {
                    <button
                        mat-menu-item
                        (click)="onRequestMenuItemClick('undeclare')"
                    >
                        {{ 'undeclare' | translate }}
                    </button>
                }
            </mat-menu>
        }
    }

    @if (entity === 'newloanDisbursementTableEntity') {
        @if (
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [label]="'disbursement'"
                (afterClick)="onRequestMenuItemClick('disburse')"
                [type]="'primary'"
            />
        }
    }

    @if (entity === 'clf_profile_component') {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            <button mat-menu-item (click)="onViewClick()">
                {{ 'viewApplication' | translate }}
            </button>
        </mat-menu>
    }

    @if (entity === 'clf-meeting-component') {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            <button mat-menu-item (click)="onRequestMenuItemClick('viewLast')">
                {{ 'viewLastMeeting' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onRequestMenuItemClick('list')">
                {{ 'listOfMeetings' | translate }}
            </button>
        </mat-menu>
    }

    @if (entity === 'vo_profile_component') {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            <button
                mat-menu-item
                (click)="onRequestMenuItemClick('registration_certificate')"
            >
                {{ 'registrationCertificate' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button
                mat-menu-item
                (click)="onRequestMenuItemClick('resolution_copy')"
            >
                {{ 'memberIDCard' | translate }}
            </button>
        </mat-menu>
    }

    @if (entity === 'crp-mapping-profile') {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            <button mat-menu-item (click)="onRequestMenuItemClick('view')">
                {{ 'viewMapping' | translate }}
            </button>
        </mat-menu>
    }

    @if (entity === 'shg_members_list') {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            <button
                mat-menu-item
                (click)="onRequestMenuItemClick('registrationCertificate')"
            >
                {{ 'registrationCertificate' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button
                mat-menu-item
                (click)="onRequestMenuItemClick('memberIdCard')"
            >
                {{ 'memberIdCard' | translate }}
            </button>
        </mat-menu>
    }

    @if (entity === 'cbo-mapping-profile') {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            <button mat-menu-item (click)="onRequestMenuItemClick('view')">
                {{ 'viewMapping' | translate }}
            </button>
        </mat-menu>
    }

    @if (entity === 'clf-transaction-meeting-component') {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            @if (
                loginInfo.subRoles.includes(roles.CLF_BK) &&
                roleAccess.canEditClfMeeting()
            ) {
                <button
                    mat-menu-item
                    [disabled]="rowData.flagOpen === 'o'"
                    (click)="
                        rowData.flagOpen !== 'o' &&
                            onRequestMenuItemClick('generateMeeting')
                    "
                >
                    {{ 'generateMeeting' | translate }}
                </button>
                <mat-divider></mat-divider>
            }
            <button
                mat-menu-item
                *ngIf="rowData.isActive"
                (click)="onRequestMenuItemClick('viewLastMeeting')"
            >
                {{ 'viewLastMeeting' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button
                mat-menu-item
                *ngIf="rowData.isActive"
                (click)="onRequestMenuItemClick('listOfMeetings')"
            >
                {{ 'listOfMeetings' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button
                mat-menu-item
                *ngIf="rowData.isOpenTransaction"
                (click)="onRequestMenuItemClick('openTransaction')"
            >
                {{ 'openTransaction' | translate }}
            </button>
        </mat-menu>
    }

    @if (
        entity === 'clf-receipts' ||
        entity === 'disbursementDetailTableEntity' ||
        entity === 'otherPaymentDetailsTableEntity' ||
        entity === 'transactionDetailsTableEntity' ||
        entity === 'disbursementDetailsTableEntity'
    ) {
        <lokos-button
            [type]="'icon'"
            [isIcon]="true"
            [iconPath]="'assets/images/eye.svg'"
            (afterClick)="onViewClick()"
            [changeIconTheme]="true"
            [iconWidth]="'1.5rem'"
            [iconHeight]="'1.5rem'"
        />
        @if (
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/trash.svg'"
                (afterClick)="onDeleteClick()"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
                [disabled]="!rowData.isDisabled"
            />
        }
    }

    @if (entity === 'shg_verification_details') {
        <button
            class="verification-button"
            [ngClass]="rowData.profile_status === 'approve' ? 'approve' : ''"
            (click)="
                verificationButtonSelected = 'approve';
                onRequestMenuItemClick('approve')
            "
        >
            <img src="assets/images/verify.svg" alt="" />
        </button>
        @if (rowData.identifierDisplay !== 'Aadhaar') {
            <button
                class="verification-button"
                [ngClass]="rowData.profile_status === 'reject' ? 'reject' : ''"
                (click)="
                    verificationButtonSelected = 'reject';
                    onRequestMenuItemClick('reject')
                "
            >
                <img src="assets/images/reject.svg" alt="" />
            </button>
        }
    }

    @if (entity === 'clf-list-of-meetings') {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            @if (
                rowData.rawMtgType !== 11 &&
                loginInfo?.subRoles?.includes(roles.CLF_BK) &&
                roleAccess.canEditClfMeeting()
            ) {
                <button
                    mat-menu-item
                    [disabled]="
                        rowData.flagOpen === 'Closed' ||
                        !rowData.previousMeetingClosed
                    "
                    (click)="onRequestMenuItemClick('closeMeeting')"
                >
                    {{ 'closeMeeting' | translate }}
                </button>
                <mat-divider></mat-divider>
            }
            @if (
                loginInfo?.subRoles?.includes(roles.CLF_BK) &&
                rowData.flagOpen === 'Closed' &&
                roleAccess.canEditClfMeeting()
            ) {
                <button
                    mat-menu-item
                    [disabled]="
                        rowData.uid !== rowData.pastMeetingId ||
                        (rowData.rawMtgType === 11 &&
                            rowData.approvalStatus !== 2)
                    "
                    (click)="onRequestMenuItemClick('reOpenMeeting')"
                >
                    {{ 'reopenMeeting' | translate }}
                </button>
                <mat-divider></mat-divider>
            }
            @if (
                rowData.flagOpen !== 'Closed' &&
                loginInfo?.subRoles?.includes(roles.CLF_BK) &&
                roleAccess.canEditClfMeeting()
            ) {
                <button
                    mat-menu-item
                    [disabled]="rowData.flagOpen === 'Closed'"
                    (click)="onRequestMenuItemClick('deleteMeeting')"
                >
                    {{ 'deleteMeeting' | translate }}
                </button>
                <mat-divider></mat-divider>
            }
            @if (rowData.flagOpen === 'Closed') {
                <button
                    mat-menu-item
                    (click)="onRequestMenuItemClick('openFinReport')"
                >
                    {{ 'financialReport' | translate }}
                </button>
                <mat-divider></mat-divider>
            }
            @if (
                rowData.approvalStatus === 1 &&
                rowData.flagOpen === 'Closed' &&
                (rowData.rawMtgType === 11 || rowData.rawMtgType === 0) &&
                roleAccess.canApproveRejectMeeting()
            ) {
                <button
                    mat-menu-item
                    (click)="onRequestMenuItemClick('approveRejectMeeting')"
                >
                    {{ 'approve' | translate }} / {{ 'reject' | translate }}
                </button>
            }
        </mat-menu>
    }

    @if (
        entity === 'cut-off-meeting-bank' || entity === 'cut-off-meeting-cash'
    ) {
        @if (
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/pencil.svg'"
                (afterClick)="onRequestMenuItemClick('edit')"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
            />
        }
    }

    @if (
        entity === 'cut-off-meeting-borrow-closed-loan' ||
        entity === 'cut-off-meeting-lending-closed-loan' ||
        entity === 'cut-off-meeting-borrow-open-loan' ||
        entity === 'cut-off-meeting-lending-open-loan' ||
        entity === 'regular-meeting-loan-request'
    ) {
        @if (
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/pencil.svg'"
                (afterClick)="onRequestMenuItemClick('edit')"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
                [disabled]="
                    entity === 'regular-meeting-loan-request' &&
                    !!rowData.disbursement_date
                "
            />
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/trash.svg'"
                (afterClick)="onRequestMenuItemClick('delete')"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
                [disabled]="
                    entity === 'regular-meeting-loan-request' &&
                    !!rowData.disbursement_date
                "
            />
        }
    }

    @if (entity === 'cutoff-summary-innovation-transaction-table') {
        @if (
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/trash.svg'"
                (afterClick)="onRequestMenuItemClick('delete')"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
            />
        }
    }

    @if (
        entity === 'cut-off-meeting-fd-streenidhi' ||
        entity === 'cut-off-meeting-fd-bank' ||
        entity === 'cut-off-share-capital' ||
        entity === 'clf-meeting-journal-voucher'
    ) {
        @if (
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/trash.svg'"
                (afterClick)="onRequestMenuItemClick('delete')"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
            />
        }
    }

    @if (
        entity === 'clf-meeting-details-contra' ||
        entity === 'clf-meeting-adjustment-delete'
    ) {
        @if (
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/trash.svg'"
                (afterClick)="onRequestMenuItemClick('delete')"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
                [disabled]="!rowData.isDisabled"
            />
        }
    }

    @if (
        entity === 'clf-meetings-clf-cash' || entity === 'clf-meetings-clf-bank'
    ) {
        @if (
            rowData.showDelete &&
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/trash.svg'"
                (afterClick)="onRequestMenuItemClick('delete')"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
                [disabled]="!rowData.showDelete"
            />
        }
    }

    @if (entity === 'clf-meeting-adjustment-adjust') {
        @if (
            !rowData.isAdjusted &&
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [label]="'adjust'"
                [type]="'primary'"
                (afterClick)="onRequestMenuItemClick('adjust')"
            />
        }
    }

    @if (
        entity === 'cut-off-lending-shg' ||
        entity === 'cut-off-lending-pg-pe' ||
        entity === 'cut-off-lending-clf' ||
        entity === 'cut-off-lending-vo' ||
        entity === 'cut-off-meeting-borrowings-active-loan-bank'
    ) {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            @if (
                entity !== 'cut-off-meeting-borrowings-active-loan-bank' &&
                entity !== 'cut-off-lending-clf' &&
                loginInfo?.subRoles?.includes(roles.CLF_BK) &&
                roleAccess.canEditClfMeeting()
            ) {
                <button
                    mat-menu-item
                    [disabled]="rowData.lastMeetingStatus === 'Closed'"
                    (click)="onRequestMenuItemClick('edit')"
                >
                    <mat-icon>edit</mat-icon> {{ 'edit' | translate }}
                </button>
                <mat-divider></mat-divider>
            }
            <button mat-menu-item (click)="onRequestMenuItemClick('info')">
                <mat-icon>info_outline</mat-icon> {{ 'info' | translate }}
            </button>
            @if (
                loginInfo?.subRoles?.includes(roles.CLF_BK) &&
                roleAccess.canEditClfMeeting()
            ) {
                <mat-divider></mat-divider>
                <button
                    mat-menu-item
                    [disabled]="rowData.lastMeetingStatus === 'Closed'"
                    (click)="onRequestMenuItemClick('delete')"
                >
                    <mat-icon>delete_outline</mat-icon>
                    {{ 'delete' | translate }}
                </button>
            }
        </mat-menu>
    }

    @if (entity === 'add-institution-department-dialog') {
        @if (
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/pencil.svg'"
                (afterClick)="onRequestMenuItemClick('edit')"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
            />
        }
    }

    @if (entity === 'aajeevika_livelihood_activity') {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="livelihoodMenu"
        />
        <mat-menu #livelihoodMenu="matMenu" class="mat-elevation-z3">
            <button
                mat-menu-item
                (click)="onRequestMenuItemClick('currentDetails')"
            >
                {{ 'currentDetails' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button
                mat-menu-item
                (click)="onRequestMenuItemClick('comparativeAnalysis')"
            >
                {{ 'comparativeAnalysis' | translate }}
            </button>
            <mat-divider></mat-divider>
        </mat-menu>
    }

    @if (entity === 'aajeevika_member_list') {
        <lokos-button
            [type]="'icon'"
            [isIcon]="true"
            [iconPath]="'assets/images/eye.svg'"
            (afterClick)="onRequestMenuItemClick('view')"
            [changeIconTheme]="true"
            [iconWidth]="'1.5rem'"
            [iconHeight]="'1.5rem'"
        />
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="aajeevikaMemberMenu"
        />
        <mat-menu #aajeevikaMemberMenu="matMenu" class="mat-elevation-z3">
            <button
                mat-menu-item
                [disabled]="rowData.approvalStatus !== 'Pending'"
                (click)="onRequestMenuItemClick('approve')"
            >
                {{ 'approve' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button
                mat-menu-item
                [disabled]="
                    rowData.approvalStatus !== 'Pending' &&
                    rowData.approvalStatus !== 'Reconsideration'
                "
                (click)="onRequestMenuItemClick('reject')"
            >
                {{ 'reject' | translate }}
            </button>
            <ng-container
                *ngIf="
                    rowData.approvalStatus === 'Approved' &&
                    rowData.isReconsider
                "
            >
                <mat-divider></mat-divider>

                <button
                    mat-menu-item
                    (click)="onRequestMenuItemClick('reconsideration')"
                >
                    {{ 'reconsideration' | translate }}
                </button>
            </ng-container>
        </mat-menu>
    }

    @if (entity === 'aajeevika_epdt_list') {
        <lokos-button
            [type]="'icon'"
            [isIcon]="true"
            [iconPath]="'assets/images/eye.svg'"
            (afterClick)="onRequestMenuItemClick('view')"
            [changeIconTheme]="true"
            [iconWidth]="'1.5rem'"
            [iconHeight]="'1.5rem'"
        />
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="epdtMenu"
        />
        <mat-menu #epdtMenu="matMenu" class="mat-elevation-z3">
            <button mat-menu-item (click)="onRequestMenuItemClick('view')">
                {{ 'viewDetails' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button
                mat-menu-item
                [disabled]="rowData.status !== 3"
                (click)="onRequestMenuItemClick('history')"
            >
                {{ 'rejectionHistory' | translate }}
            </button>
        </mat-menu>
    }

    @if (entity === 'regular-meeting-attendance') {
        <button
            class="attendance-btn"
            [class.selected-present]="rowData.attendance === 'p'"
            (click)="onRequestMenuItemClick('present')"
        >
            P
        </button>
        <button
            class="attendance-btn"
            [class.selected-absent]="rowData.attendance === 'a'"
            (click)="onRequestMenuItemClick('absent')"
        >
            A
        </button>
    }

    @if (
        entity === 'shg-meeting-list-comoponent' ||
        entity === 'vo-meeting-list-comoponent'
    ) {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="requestMenu"
        />
        <mat-menu #requestMenu="matMenu" class="mat-elevation-z3">
            <button mat-menu-item (click)="onRequestMenuItemClick('refresh')">
                {{ 'refresh' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onRequestMenuItemClick('ledger')">
                {{ 'loanLedger' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onRequestMenuItemClick('fdmFund')">
                {{ 'fundsFromFdm' | translate }}
            </button>
        </mat-menu>
    }

    @if (entity === 'paymentDetailsTableEntity') {
        @if (
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [type]="'primary'"
                [label]="'modeOfPayment'"
                (afterClick)="onRequestMenuItemClick('add')"
            />
        }
    }
    @if (
        entity === 'shg-regular-loan-ledger-table' ||
        entity === 'vo-regular-loan-ledger-table'
    ) {
        <img
            src="assets/images/threeDot.svg"
            alt="threeDot"
            class="click-area"
            [mat-menu-trigger-for]="epdtMenu"
        />
        <mat-menu #epdtMenu="matMenu" class="mat-elevation-z3">
            <button mat-menu-item (click)="onRequestMenuItemClick('view')">
                {{ 'viewDetails' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onRequestMenuItemClick('schedule')">
                {{ 'loanSchedule' | translate }}
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onRequestMenuItemClick('repayment')">
                {{ 'repaymentHistory' | translate }}
            </button>
        </mat-menu>
    }

    @if (
        entity === 'open-transaction' || entity === 'cut-off-compulsory-savings'
    ) {
        @if (
            loginInfo?.subRoles?.includes(roles.CLF_BK) &&
            roleAccess.canEditClfMeeting()
        ) {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/trash.svg'"
                (afterClick)="onDeleteClick()"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
                [disabled]="rowData.isLatestTxn"
            />
        }
    }

    @if (
        entity === 'vo-meeting-regular-bank-reconcilation' ||
        entity === 'shg-meeting-regular-bank-reconcilation'
    ) {
        <lokos-button
            [type]="'icon'"
            [isIcon]="true"
            [iconPath]="'assets/images/eye.svg'"
            (afterClick)="onRequestMenuItemClick('view')"
            [changeIconTheme]="true"
            [iconWidth]="'1.5rem'"
            [iconHeight]="'1.5rem'"
        />
    }
</div>
